module["exports"] = ["N", "E", "S", "W", "NE", "NW", "SE", "SW"];